import { styled } from "@vitality-ds/system";
import BaseFlexStyles from "./styles/BaseFlex.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseFlex = styled("div", BaseFlexStyles);